import styled, {css} from 'styled-components';

import {media, flipOnLTR} from '~/shared/theme/utils';
import {screenReaderNotificatorCss} from '~/shared/components/styled';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import poweredByGoogleImgUrl from '~/assets/images/powered_by_google_on_white.png';
import {flexColumn, flexCenterVertically, flexColumnCenterVertically} from '~/shared/theme/FlexLayout';
import currentLocation from '~/assets/images/icons/currentLocation.svg';
import pinRestaurant from '~/assets/images/icons/pin_restaurant.svg';

export const PoweredByGoogleImg = styled(ImageWithAlt).attrs(({alt}) => ({
  title: alt,
  src: poweredByGoogleImgUrl,
}))``;

export const PoweredByGoogleWrapper = styled.div`
  ${flexColumnCenterVertically};
  display: ${({shouldShow}) => (shouldShow ? 'flex' : 'none')};
  align-items: flex-end;
  height: 34px;
  padding: 0 5px;
  background-color: ${({
    theme: {
      addressFinder: {
        resultsContainer: {backgroundColor},
      },
    },
  }) => backgroundColor};
`;

export const DropdownContainer = styled.ul.attrs({
  id: 'homePage_DropDownAddress',
  role: 'listbox',
  className: 'white-border-on-contrast',
})`
  width: calc(100% + 56px);
  ${media.minLargeTablet`
    width: calc(100% + 85px);
  `}
  margin: 0;
  padding: 0;
  position: absolute;
  top: 100%;
  ${flexColumn};
  background-color: ${({theme}) => theme.addressFinder.resultsContainer.backgroundColor};
  z-index: 2;
  box-shadow: ${({theme}) => theme.shadows.shadow3};
  ${flipOnLTR`
    right: 0;
  `}
`;

export const Input = styled.input.attrs({
  id: 'homePage_SelectAddress',
})`
  width: 100%;
  height: 100%;
  border: 0;
  ${flipOnLTR`
    padding-right: 46px;
  `}
  background-color: ${({theme}) => theme.colors.surface};
  color: ${({theme}) => theme.colors.secondary};

  ::placeholder {
    color: ${({theme}) => theme.colors.secondary};
    opacity: 1;
  }

  &&& {
    font-size: ${({isAddAddressMode}) => (isAddAddressMode ? 16 : 18)}px;
    font-family: TakeawaySans, sans-serif;
  }
`;

export const SuggestionItem = styled.li.attrs(({id}) => ({id}))`
  background-color: ${({active, theme}) =>
    (active
      ? theme.addressFinder.suggestionItem.backgroundColor.activeColor
      : theme.addressFinder.suggestionItem.backgroundColor.regularColor)};
  cursor: pointer;
  ${flexCenterVertically};
  line-height: 17px;
  font-size: ${({isAddAddressMode}) => (isAddAddressMode ? 16 : 18)}px;
  height: 47px;
  color: ${({isCurrentLocation, theme}) =>
    (isCurrentLocation ? theme.colors.surfacePrimaryAction : theme.colors.secondary)};

  &:hover,
  &:focus {
    background-color: ${({theme}) => theme.addressFinder.suggestionItem.backgroundColor.activeColor};
  }
`;

export const SuggestionItemIcon = styled(ImageWithAlt).attrs(({isCurrentLocation}) => ({
  src: isCurrentLocation ? currentLocation : pinRestaurant,
  noAlt: true,
}))`
  width: 20px;
  height: 31px;
  ${({isCurrentLocation}) =>
    isCurrentLocation &&
    css`
      width: 16px;
      height: 16px;
    `}
  ${flipOnLTR`
    margin-right: 9px;
    margin-left: 10px;
  `}
  ${media.minTablet`
    ${flipOnLTR`
      margin-right: 14px;
    `}
  `}
`;

export const BoldResultContainer = styled.div`
  display: inline-block;
`;

export const ScreenReaderNotificator = styled.label.attrs({
  htmlFor: 'homePage_SelectAddress',
})`
  ${screenReaderNotificatorCss}
`;

/* eslint-disable max-len */
const SearchIconSvg = ({className}) => (
  <svg
    className={className}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="elements/icons/24x24/Search" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icons/Search" transform="translate(1.000000, 1.000000)" fill="#0A3847">
        <path d="M19.6382079,22 C19.2192595,22 18.8003111,21.835 18.4811902,21.5041538 L15.2081555,18.1195385 C14.5690955,17.4586923 14.5690955,16.3874615 15.2081555,15.7266154 C15.8463973,15.0657692 16.8839493,15.0657692 17.522191,15.7266154 L20.7952257,19.1112308 C21.4342857,19.7720769 21.4342857,20.8433077 20.7952257,21.5041538 C20.4761048,21.835 20.0571564,22 19.6382079,22" />
        <path d="M9.8195131,0 C4.39691293,0 0.000409129332,4.54638462 0.000409129332,10.1538462 C0.000409129332,15.7613077 4.39609467,20.3076923 9.81869484,20.3076923 C15.241295,20.3076923 19.6386171,15.7613077 19.6386171,10.1538462 C19.6386171,4.54638462 15.2421133,0 9.8195131,0 M9.8195131,3.38461538 C11.5681319,3.38461538 13.2120135,4.08861538 14.4484024,5.36715385 C15.683973,6.64569231 16.3655824,8.34561538 16.3655824,10.1538462 C16.3655824,13.8862308 13.4288521,16.9230769 9.81869484,16.9230769 C8.07007608,16.9230769 6.42701268,16.2190769 5.18980558,14.9405385 C3.954235,13.662 3.27344379,11.9620769 3.27344379,10.1538462 C3.27344379,6.42146154 6.20935587,3.38461538 9.8195131,3.38461538" />
      </g>
    </g>
  </svg>
);

export const StyledSearchIconSvg = styled(SearchIconSvg)`
  width: 18px;
  position: absolute;
  top: 0;
  ${flipOnLTR`
    right: 15px;
  `}
  ${flexColumnCenterVertically};
  height: 100%;
  padding: 0;
  margin: 0;
`;
